import React, { Component } from "react";
import { Button, Modal, Tooltip } from "antd";
//import TrackedWebsiteWizard from "../TrackedWebsitesWizard/TrackedWebsiteWizard";
import AddTrackedWebsiteWizardContainer from "../../../../containers/AddTrackedWebsiteWizardContainer";

export default class AddNewTrackedWebsite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isAddingTrackedWebsite: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isAddingTrackedWebsite === false && prevProps.isAddingTrackedWebsite === true) {
      this.setState(_ => ({ visible: false }));
    }
  }

  toggleModal() {
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  }

  render() {
    return (
      <div>
        <Tooltip placement="topRight" title="Track new website">
          {this.props.label && (
            <Button type="primary" icon="plus" onClick={this.toggleModal} data-cy="add-new-tracked-website">
              {this.props.label}
            </Button>
          )}
          {!this.props.label && (
            <Button type="primary" icon="plus" data-cy="add-new-tracked-website" onClick={this.toggleModal} />
          )}
        </Tooltip>

        <Modal
          className="tracked-websites-wizard-modal"
          visible={this.state.visible}
          title="Add new website"
          footer={null}
          onCancel={this.toggleModal}
          destroyOnClose={true}
          maskClosable={false}>
          {/* <TrackedWebsiteWizard
            onAddTrackedWebsite={url => this.props.onAddTrackedWebsite(url)}
            isAddingTrackedWebsite={this.props.isAddingTrackedWebsite}
          /> */}
          <AddTrackedWebsiteWizardContainer showStartScreen={false} showSkip={false} />
        </Modal>
      </div>
    );
  }
}
